import { FirebaseOptions } from "firebase/app";

// Service config of the environment the app is built for. Create React App
// inlines REACT_APP_* variables at build time: deployments take them from the
// GitHub environment, local runs from the .env files. See docs/deployment.md.

function requireEnv(name: string, value: string | undefined): string {
  if (!value?.trim()) {
    throw new Error(`${name} is not set. See docs/deployment.md.`);
  }

  return value.trim();
}

// Web app config from the Firebase console, as JSON.
export const FIREBASE_CONFIG: FirebaseOptions = JSON.parse(
  requireEnv("REACT_APP_FIREBASE_CONFIG", process.env.REACT_APP_FIREBASE_CONFIG)
);

// OAuth web client ID for Google sign-in.
export const GOOGLE_CLIENT_ID = requireEnv(
  "REACT_APP_GOOGLE_CLIENT_ID",
  process.env.REACT_APP_GOOGLE_CLIENT_ID
);

// Services ID for Sign in with Apple.
export const APPLE_CLIENT_ID = requireEnv(
  "REACT_APP_APPLE_CLIENT_ID",
  process.env.REACT_APP_APPLE_CLIENT_ID
);

// Sentry's DSN. Optional: without it, errors aren't reported.
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN?.trim() || undefined;

// The deployment, `staging` or `production`, for Sentry.
export const SENTRY_ENVIRONMENT =
  process.env.REACT_APP_SENTRY_ENVIRONMENT?.trim() || "development";

// The build, `website@<version>+<short commit>`, for Sentry.
export const SENTRY_RELEASE =
  process.env.REACT_APP_SENTRY_RELEASE?.trim() || undefined;

// How many page loads and navigations Sentry traces, from 0 to 1.
export const SENTRY_TRACES_SAMPLE_RATE =
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE?.trim() || undefined;
